import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectIsModalSignInRestrictEnabled } from '../../../redux/diagram/diagram.selectors';
import { disableModalSignInRestrict } from '../../../redux/diagram/diagram.actions';

import Modal from '../Modal/Modal';
import './ModalSignInRestriction.scss';

export const ModalSignInRestriction = () => {
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();

    const isOpen = useSelector(selectIsModalSignInRestrictEnabled);

    const handleCancel = () => {
        dispatch(disableModalSignInRestrict());
    };

    const handleSignIn = () => {
        // setTimeout(() => { window.location.href = 'https://app.dbdesign.io/sign-in'; }, 150);
        setTimeout(() => { window.open('https://app.dbdesign.io/sign-in', '_blank'); }, 150)
    };

    const handleSignUp = () => {
        // setTimeout(() => { window.location.href = 'https://app.dbdesign.io/sign-up'; }, 150);
        setTimeout(() => { window.open('https://app.dbdesign.io/sign-up', '_blank'); }, 150)
    };

    return (
        <Modal
            isOpen={isOpen}
            modalClass={`modal-sign-in-restrict`}
            onCancel={handleCancel}
        >
            {/* <div className="modal-content-header">{`Sign in to access this feature`}</div> */}
            <div className="modal-content-header">{t('m_sign_in_restrict.title')}</div>
            <div className="modal-content-body">
                <div className='description-text'>{t('m_sign_in_restrict.subtitle')}</div>
                <button onClick={() => handleSignIn()}>{t('b.sign_in')}</button>
                <button className="secondary" onClick={() => handleSignUp()}>{t('b.sign_up')}</button>
            </div>
        </Modal>
    );
};

export default ModalSignInRestriction;
